import { Box, CircularProgress } from '@mui/material';

interface LoadingProps {
  text: string;
}

export default function Loading({ text }: LoadingProps) {
  return (
    <Box sx={{ mt: { xs: 15, sm: 25 }, mb: 2, textAlign: 'center' }}>
      <CircularProgress />
      <p>{text}</p>
    </Box>
  );
}
